const url = "./assets/page/steps/step4/icons/";

const options = [
    {
        content: " ",
        icon: true,
        text: "Nenhuma",
        url: `${url}aditional1_any.svg`,
    },
    {
        content: "confetti",
        icon: true,
        text: "Confetes",
        url: `${url}aditional1_confetti.svg`,
    },
    {
        content: "peanut",
        icon: true,
        text: "Amendoim",
        url: `${url}aditional1_peanut.svg`,
    },
    {
        content: "granulated",
        icon: true,
        text: "Granulado",
        url: `${url}aditional1_granulated.svg`,
    },
    {
        content: "chocoball",
        icon: true,
        text: "Chocobol",
        url: `${url}aditional1_chocoball.svg`,
    },
];

export default options;
